import { PERMISSIONS } from '@conversed/shared/src/central/constants/permissions';
import z from 'zod';
import { createRESTContract } from '../../index';
import {
  EmailTemplateSchema,
  UpdateEmailTemplateSchema,
} from './email-template.schema';

export const emailTemplateContract = createRESTContract({
  getEmailTemplateByType: {
    method: 'GET',
    path: '/email-template/:type',
    permissions: [PERMISSIONS.EMAIL_TEMPLATE.INVITE_EMAIL_TEMPLATE_EDIT],
    response: EmailTemplateSchema.optional(),
  },
  updateEmailTemplate: {
    method: 'POST',
    path: '/email-template',
    permissions: [PERMISSIONS.EMAIL_TEMPLATE.INVITE_EMAIL_TEMPLATE_EDIT],
    body: UpdateEmailTemplateSchema,
    response: z.void(),
  },
});
